import { ADMIN_LINEUP } from '../../constants/actions';
import { LOCATION_CHANGE } from 'react-router-redux';

const initialState = {
    fetched: false,
    fetching: false,
    listView: false,
    sortBy: 'stageName',
    order: 'asc',
    stages: [],
    entries: {},
    artists: [],
    selectedEntries: []
};

function lineup(state = initialState, action) {
    switch (action.type) {
        case ADMIN_LINEUP.FETCH_START:
            return { ...state, fetching: true };
        case ADMIN_LINEUP.REFRESH:
            return { ...state, fetching: false, fetched: false };
        case ADMIN_LINEUP.ADD:
            return { ...state, [action.field]: (state[action.field] || []).concat(action.value) };
        case ADMIN_LINEUP.UPDATE:
            return { ...state, [action.field]: action.value };
        case ADMIN_LINEUP.FETCH_OK:
            return {
                ...state,
                fetching: false,
                fetched: true,
                artists: action.artists,
                stages: action.stages,
                entries: action.entries
            };
        case LOCATION_CHANGE:
            return initialState;
        default:
            return state;
    }
}

export default lineup;
